export default __webpack_public_path__ + "static/media/camera.0f69ee63.svg";